// extracted by mini-css-extract-plugin
module.exports = {"videosGrid":"VideosGrid_videosGrid__58VYd"};